import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  loading: boolean = false;

  constructor() { 
    this.loading = true;
  }
  
  async ngOnInit(): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.loading = false;
  }
}
